import { useEffect, useState } from 'react';
import { footerApi, type FooterGroup } from '../api';
import { env } from '@/config/env';

function toAbsoluteUrl(u?: string) {
  if (!u) return '';
  if (/^https?:\/\//i.test(u)) return u;
  const base = env.apiUrl.replace(/\/$/, '');
  return `${base}/${u.replace(/^\//, '')}`;
}

export function PublicFooter() {
  const [groups, setGroups] = useState<FooterGroup[]>([]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const res = await footerApi.getPublicFooter();
        if (!cancelled) setGroups(res.groups || []);
      } catch {
        if (!cancelled) setGroups([]);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!groups.length) return null;

  return (
    <div className="w-full space-y-5">
      {groups.map((group) => (
        <div key={group.id}>
          <p className="text-xs text-center text-muted-foreground uppercase tracking-wider mb-2">{group.label}</p>
          <div className="overflow-x-auto">
            <div className="flex min-w-full justify-center">
              <div className="flex items-center justify-center gap-4 w-max px-2 py-1">
                {(group.items || []).map((item) => {
                  const logo = (
                    <img
                      src={toAbsoluteUrl(item.image_path)}
                      alt={item.label || group.label}
                      className="h-[68px] w-[68px] object-contain rounded border bg-white p-1"
                    />
                  );
                  return item.url ? (
                    <a
                      key={item.id}
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center"
                      aria-label={item.label || group.label}
                    >
                      {logo}
                    </a>
                  ) : (
                    <div key={item.id} className="inline-flex items-center" aria-label={item.label || group.label}>
                      {logo}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
